import { render, staticRenderFns } from "./TifDistricts.vue?vue&type=template&id=f659bf46&"
import script from "./TifDistricts.vue?vue&type=script&lang=js&"
export * from "./TifDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports